<template>
  <div v-if="isOpen" class="user-dropdown">
    <div class="user-info">
      <img src="@/assets/avatar.png" alt="头像" class="avatar" />
      <p class="username">{{ user.name }} 欢迎您！</p>
    </div>
    <div class="dropdown-menu">
      <router-link to="/user-profile" class="menu-item">个人中心</router-link>
      <button class="menu-item" @click="handleLogout">退出登录</button>
    </div>
    <div class="additional-info">
      <p>其他简要文字信息...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserDropdown',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  emits: ['logout'],
  methods: {
    handleLogout() {
      // 处理退出登录逻辑
      // alert('退出登录');
      this.$emit('logout');
    },
  },
};
</script>

<style scoped>
.user-dropdown {
  position: absolute;
  top: 60px;
  right: 10px;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 200px;
  z-index: 1000;
}

.user-info {
  padding: 10px;
  border-bottom: 1px solid #ddd;
  text-align: center;
}

.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.username {
  margin: 5px 0 0;
  font-size: 14px;
  font-weight: bold;
}

.dropdown-menu {
  padding: 10px 0;
}

.menu-item {
  display: block;
  width: 100%;
  padding: 8px 10px;
  text-align: left;
  border: none;
  background: none;
  cursor: pointer;
  font-size: 14px;
  color: #333;
}

.menu-item:hover {
  background-color: #f5f5f5;
}

.additional-info {
  padding: 10px;
  font-size: 12px;
  color: #666;
  border-top: 1px solid #ddd;
}
</style>